export enum TradingSystemStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    APPROACHING = "APPROACHING"
}
